import buildSimpleStringFilter from '../buildSimpleStringFilter'

const SellerGradeFilter = buildSimpleStringFilter({
  key: 'sellerGrade',
  expandedOnInit: true,
})

export default SellerGradeFilter
